<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="960"
  >
    <v-card
      flat
      tile
      class="grey lighten-3"
    >
      <v-card
        id=""
        class="pa-3 grey lighten-3"
        flat
        tile
        height="528"
        style="position:relative;"
      >
        <div
          id="map"
          ref="map"
        >
          <MapView2
            :timing="timing"
            :esti-i-d="estiID"
            @drawed="handleDrawed"
          />
        </div>

        <v-card
          id="portListCon"
          class="px-3 mt-1"
        >
          <template v-for="(port, i) in routeOnlyPorts">
            <v-divider
              v-if="i!==0"
              :key="`${i}-divider`"
            />
            <v-row
              dense
              no-gutters
              class="py-2"
              align="center"
            >
              <v-col
                cols="7"
                class=""
              >
                <template v-if="port.wt=='1'">
                  <span class="font-italic text-caption font-weight-bold">{{ port.wn }}</span>
                </template>
                <template v-else>
                  <span class="text-caption font-weight-bold">{{ port.wn }}</span>
                </template>
              </v-col>
              <v-col
                cols="5"
                class="text-caption text-right"
              >
                {{ _.round(routeOnlyPorts[i].gVal, 2) }} {{ $t('m.nm') }}
              </v-col>
            </v-row>
          </template>
        </v-card> <!-- end 港口列表 -->

        <div id="settingFabPad">
          <v-btn
            class=""
            small
            fab
            color="grey lighten-2"
            @click="handleCancel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-btn
            class="mt-4"
            small
            fab
            dark
            color="blue"
            @click="changeWayPoint"
          >
            <v-icon>mdi-router</v-icon>
          </v-btn>

          <v-btn
            class="mt-4"
            small
            fab
            dark
            color="brown darken-1"
            @click="changeTurn"
          >
            <v-icon>mdi-navigation</v-icon>
          </v-btn>
        </div>

        <div
          id="wayPointConfigCon"
          class="mx-auto mt-1"
          v-if="routeLayerVisible"
        >
          <v-toolbar
            dense
            light
            class=""
            color="transparent"
          >
            <v-toolbar-title class="text-body-2">
              Route Option
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              icon
              @click="resetWayPointSetting"
            >
              <v-icon class="">
                mdi-backup-restore
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="closeWayPointSetting"
            >
              <v-icon
                class=""
                color="primary"
              >
                mdi-check-bold
              </v-icon>
            </v-btn>
          </v-toolbar>
        </div> <!-- end wayPointConfigCon -->

        <div
          id="turningConfigCon"
          class="mx-auto mt-1"
          v-if="turnLayerVisible"
        >
          <v-toolbar
            dense
            light
            class=""
            color="transparent"
          >
            <v-toolbar-title class="text-body-2">
              {{ $t('m.turningConfig') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              icon
              @click="resetTurningSetting"
            >
              <v-icon class="">
                mdi-backup-restore
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="closeTurningSetting"
            >
              <v-icon class="">
                mdi-close
              </v-icon>
            </v-btn>
          </v-toolbar>
        </div>
      </v-card> <!-- end workspace -->

      <v-overlay :value="isLoading">
        <v-progress-circular
          indeterminate
          size="48"
        />
      </v-overlay>
    </v-card> <!-- end 最外层 card -->
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import MapView2 from './MapView2'
import * as esriLoader from 'esri-loader'
import MapUtil from '@/utils/mapUtil'

export default {
  name: 'MapEditDialog',
  components: {
    MapView2
  },
  props: [
    'visible', 'estiID', 'viewFlag'
  ],
  data () {
    return {
      dialog: false,
      dialogTitle: null,
      timing: null,

      isLoading: true,
      model: null,

      snackbar: false,
      snackbarText: null,

      alertConfirmDlgVisible: false,
      alertContent: ''

    }
  },
  computed: {
    ...mapState({
      currEditEsti: state => state.estimating.currEditEsti,
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance,
      shipInfo: state => state.estimating.shipInfo,
      cargoTabsArr: state => state.estimating.cargoTabsArr,

      portPointArr: state => state.estiDistance.portPointArr,
      preservedPortPointArr: state => state.estiDistance.preservedPortPointArr,
      turnLayerVisible: state => state.estiDistance.turnLayerVisible,
      routePorts: state => state.estiDistance.routePorts,
      routeOnlyPorts: state => state.estiDistance.routeOnlyPorts,
      preservedOriginRoutes: state => state.estiDistance.preservedOriginRoutes,

      routeLayerVisible: (state) => state.estiDistance.routeLayerVisible,
      excWayPointArr: (state) => state.estiDistance.excWayPointArr,
      copyExcWayPointArr: (state) => state.estiDistance.copyExcWayPointArr,
      preservedExcWayPointArr: (state) => state.estiDistance.preservedExcWayPointArr,
      requiredWayPointArr: (state) => state.estiDistance.requiredWayPointArr

    }),
    ...mapGetters({
      ttlVoyDays: 'getTtlVoyDays',
      ttlSeaDays: 'getTtlSeaDays',
      ttlPortIdleDays: 'getTtlPortIdleDays',
      ttlPortWorkDays: 'getTtlPortWorkDays'
    }),

    portIdStr () {
      var portIdArr = []
      this.portPointArr.forEach((ele, index) => {
        portIdArr.push(ele.PortID)
      })
      return portIdArr.join(',')
    }
  }, // end computed
  watch: {
    visible: function (val) {
      this.dialog = val
      if (val) {
        this.$store.commit('setResetEstiMap', false)
        this.timing = new Date().getTime()
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    handleCancel () {
      this.dialog = false
      // this.$store.commit("setIsLoaded", false)
      this.closeTurningSetting()
      this.$emit('cancel')
    },

    handleDrawed () {
      this.isLoading = false
    },

    changeWayPoint () {
      if (this.turnLayerVisible) {
        return
      }
      this.$store.commit('setRouteLayerVisibleEsti', true)
      this.$store.commit('setPreservedPortPointArrEsti'
        , _.cloneDeep(this.portPointArr))
      this.$store.commit('setPreservedExcWayPointArrEsti'
        , _.cloneDeep(this.copyExcWayPointArr))
    },
    closeWayPointSetting () {
      if (JSON.stringify(this.portPointArr) != JSON.stringify(this.preservedPortPointArr) ||
          JSON.stringify(this.copyExcWayPointArr) != JSON.stringify(this.preservedExcWayPointArr)) {
        this.getDistance()
      }
      this.$store.commit('setRouteLayerVisibleEsti', false)
    },
    resetWayPointSetting () { // 重置路由设置
      this.$store.commit('setResetWayPointFlagEsti', true)
      this.wayPointConfigChecked = _.cloneDeep(MapUtil.WAYPOINT_CONFIG)
    },

    changeTurn () { // 显示转向点
      this.$store.commit('changeTurnLayerVisibleForEsti', true)
    },
    closeTurningSetting () {
      this.$store.commit('changeTurnLayerVisibleForEsti', false)
    },
    resetTurningSetting () { // 重置转向点
      this.$store.commit('setOriginRoutesEsti', this.preservedOriginRoutes)
      this.$store.dispatch('reBuildRoutesForEsti')
      this.$store.commit('setResetTurnLayerFlagForEsti', true)
      this.$store.commit('changeTurnLayerVisibleForEsti', false)
      // this.$store.commit("setResetWayPointFlag", true)
      // this.wayPointConfigChecked = _.cloneDeep(MapUtil.WAYPOINT_CONFIG)
    },

    getDistance () {
      var portIdStr = this.portIdStr
      // this.$store.commit("setIsCalculating", true)
      this.$store.dispatch('getDistanceForEsti', { portIdStr: portIdStr }).then(() => {
        // 处理设置了路由点...
        // this.$store.commit("setRouteLayerVisible", false)
        this.$store.commit('setIsNeedCalAfterRebuild', true)
      })
    }

  }
}
</script>

<style scoped lang="scss">
  #map {
    position: absolute; top: 0; left: 0; bottom: 0; right: 0;
  }

  #settingFabPad {
    position: absolute; width: 48px; right: 16px; top: 16px; z-index: 1;
  }

  #portListCon {
    position: absolute; width: 268px;  z-index: 1;
  }

  #wayPointConfigCon {
    position: absolute; width: 320px; right: 230px; z-index: 1;
    background-color: rgba(245, 245, 245, .7)
  }

  #turningConfigCon {
    position: absolute; width: 320px; right: 200px; z-index: 1;
    background-color: rgba(245, 245, 245, .7)
  }

</style>
